/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Unpin_TitleInputs */

const en_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpin`)
};

const fr_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depingler`)
};

const de_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufheben`)
};

const it_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccare`)
};

const ru_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открепить`)
};

const es_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desprender`)
};

const zh_cn2_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消固定`)
};

const ja_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ピンを外す`)
};

const hi_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनपिन`)
};

const pt_pt2_voice_manager_unpin_title = /** @type {(inputs: Voice_Manager_Unpin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafixar`)
};

/**
* | output |
* | --- |
* | "Unpin" |
*
* @param {Voice_Manager_Unpin_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_unpin_title = /** @type {((inputs?: Voice_Manager_Unpin_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Unpin_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_unpin_title(inputs)
	if (locale === "de") return de_voice_manager_unpin_title(inputs)
	if (locale === "it") return it_voice_manager_unpin_title(inputs)
	if (locale === "ru") return ru_voice_manager_unpin_title(inputs)
	if (locale === "es") return es_voice_manager_unpin_title(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_unpin_title(inputs)
	if (locale === "ja") return ja_voice_manager_unpin_title(inputs)
	if (locale === "hi") return hi_voice_manager_unpin_title(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_unpin_title(inputs)
	return en_voice_manager_unpin_title(inputs)
});